/** @prettier */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import SportIcon from '@xanadu/ui-shared/components/SportIcon';

import { PRODUCTS } from '../../../../constants';

import styles from './Tile.module.scss';

const Tile = ({
  url,
  iconName,
  name,
  onClick,
  product,
  flat = false,
  dataHook,
  className,
  section,
  showLabel,
  isExternalLink = false,
  openInNewTab = false,
}) => {
  const invertedColors = section === 'popularSports';

  const mainProducts = section === 'popularProducts';

  const mainClass = classNames({
    [styles.main]: true,
    [styles['main--empty']]: !name,
    [styles[`main--${iconName}`]]: true,
    [styles[`main--${iconName}--popularProducts`]]: mainProducts,
    [styles['main--flat']]: flat,
    [styles['main--invertedColors']]: invertedColors,
    [styles['main--mainProducts']]: mainProducts,
    [styles['main--mainProducts--scrolling']]: mainProducts && !showLabel,
    [className]: true,
  });

  const textClass = classNames({
    [styles.text]: true,
    [styles['text--invertedColors']]: invertedColors,
    [styles['text--scrolling']]: mainProducts && !showLabel,
  });

  // If it's isExternalLink , use <a> to open in a new tab
  if (isExternalLink && url) {
    const target = openInNewTab ? '_blank' : '_self';
    return (
      <a
        href={url}
        target={target}
        rel="noopener noreferrer"
        className={mainClass}
        data-hook={dataHook}
      >
        <SportIcon
          className={styles.icon}
          sport={iconName || PRODUCTS.exchange}
          invertedColors={invertedColors}
          size={invertedColors ? '48px' : ''}
        />
        <div className={textClass}>{name}</div>
      </a>
    );
  }

  return (
    <div
      className={mainClass}
      role="button"
      onClick={() => onClick({ url, product })}
      data-hook={dataHook}
    >
      <SportIcon
        className={styles.icon}
        sport={iconName || PRODUCTS.exchange}
        invertedColors={invertedColors}
        size={invertedColors ? '48px' : ''}
      />
      <div className={textClass}>{name}</div>
    </div>
  );
};

Tile.propTypes = {
  url: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  showLabel: PropTypes.bool,
  product: PropTypes.string,
  flat: PropTypes.bool,
  dataHook: PropTypes.string,
  className: PropTypes.string,
  section: PropTypes.string,
  isExternalLink: PropTypes.bool,
  openInNewTab: PropTypes.bool,
};

Tile.defaultProps = {
  mini: false,
  colossus: false,
  virtuals: false,
};

export default Tile;
